import React, { useState } from "react";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link } from "react-router-dom";
import { capitalizeFirstLetter } from "../../utils/Utils";

const BreadcrumbsComponent = ({ title, links }) => {
  const [hover, setHover] = useState(false);

  const handleMouseEnter = () => {
    setHover(true);
  };

  const handleMouseLeave = () => {
    setHover(false);
  };

  return (
    <Box sx={{ margin: "8px", marginLeft: "24px" }}>
      <Typography
        variant="h6"
        component="div"
        sx={{ marginBottom: "8px", fontSize: "18px" }}
      >
        {capitalizeFirstLetter(title)}
      </Typography>
      <Box role="presentation" onClick={() => {}}>
        <Breadcrumbs aria-label="breadcrumb" separator="•">
          {links.map((link) => {
            if (link.path) {
              return (
                <Link
                  key={link.name}
                  style={{
                    cursor: "pointer",
                    textDecoration: hover ? "underline" : "none",
                    color: hover ? "#00AB55" : "#000",
                    fontSize: "16px"
                  }}
                  to={link.path}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  {capitalizeFirstLetter(link.name)}
                </Link>
              );
            } else {
              return (
                <Typography color="text.primary" key={link.name}>
                  {capitalizeFirstLetter(link.name)}
                </Typography>
              );
            }
          })}
          
        </Breadcrumbs>
      </Box>
    </Box>
  );
};

export default BreadcrumbsComponent;
